import { defineMessages } from 'react-intl';

export default defineMessages({
  sizeLabel: {
    id: 'ordering.productDetails.customizations.sizeLabel',
    defaultMessage: 'Size',
    description: 'Label on size selector',
  },
  sizeOptionsTitle: {
    id: 'ordering.productDetails.sizeOptionsTitle',
    defaultMessage: 'Size options',
    description: 'The title of the size selector section',
  },
  sizeWholeBeanLabel: {
    id: 'ordering.productDetails.sizeWholeBeanLabel',
    defaultMessage: 'Whole bean coffee',
    description: 'The label value for whole bean coffee',
  },
});
